import { useState } from 'react';
import {
  Link,
  makeStyles,
  mergeClasses,
  tokens,
} from '@fluentui/react-components';
import { FileViewerDialog } from '../../FileViewerDialog';
import {
  EllipsisFileName,
  getFileNameFromUrl,
  getFileTypeIcon,
} from '../../file';
import { FieldWrapper, ReadOnlyEmpty } from './FieldWrapper';
import { useFieldReadOnly } from './fieldReadOnly';
import { getFileViewerUrl } from './fileViewerUtils';
import type { IField } from '@moko/utils';

const useStyles = makeStyles({
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    minWidth: 0,
    maxWidth: '100%',
    minHeight: '32px',
    flexWrap: 'nowrap',
  },
  readOnlyLink: {
    paddingInlineStart: tokens.spacingHorizontalM,
  },
  icon: {
    flexShrink: 0,
    display: 'flex',
  },
});

export const FileViewerField = ({ field }: { field: IField }) => {
  const styles = useStyles();
  const [open, setOpen] = useState(false);
  const url = getFileViewerUrl(field.options);
  const fileName = url ? getFileNameFromUrl(url) : '';
  const isReadOnly = useFieldReadOnly(field);

  return (
    <>
      <FieldWrapper field={field}>
        {url ? (
          <Link
            as="button"
            type="button"
            onClick={() => setOpen(true)}
            className={mergeClasses(
              styles.link,
              isReadOnly && styles.readOnlyLink
            )}
          >
            <span className={styles.icon}>{getFileTypeIcon(fileName)}</span>
            <EllipsisFileName fileName={fileName} />
          </Link>
        ) : isReadOnly ? (
          <ReadOnlyEmpty />
        ) : null}
      </FieldWrapper>
      {url ? (
        <FileViewerDialog
          open={open}
          url={url}
          title={field.label}
          onClose={() => setOpen(false)}
        />
      ) : null}
    </>
  );
};
